import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v0/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v0/geodata';
import { toUrlSearchParams } from '../v1/utils';

export class GeodataService implements types.Handlers {
  private serviceEndpoint = '/geodata';

  constructor(private axios: AxiosInstance) {}
  async createReport(params: types.CreateReportParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.post(`${this.serviceEndpoint}/${params.path.geodataId}/report`)).data;
  }

  async fetchGeodataById(
    params: types.FetchGeodataByIdParameters,
  ): Promise<types.GetGeodataResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}`, {
        params: new URLSearchParams([...toUrlSearchParams('include', params.query.include)]),
      })
    ).data;
  }
  async deleteGeodata(params: types.DeleteGeodataParameters): Promise<void> {
    return (
      await this.axios.delete(`${this.serviceEndpoint}/${params.path.geodataId}`, {
        headers: {
          ...params.headers,
        },
      })
    ).data;
  }
  async pushGcpCorrectionJob({
    path,
    body,
  }: types.PushGcpCorrectionJobParameters): Promise<common.MessageOnlyResponse> {
    return (await this.axios.post(`${this.serviceEndpoint}/${path.geodataId}/gcp-job`, body)).data;
  }
  async fetchGcpCorrectionJob({
    path,
  }: types.FetchGcpCorrectionJobParameters): Promise<types.GcpCorrectionJobResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${path.geodataId}/gcp-job`)).data;
  }
  transferGeodataToProject(
    params: types.TransferGeodataToProjectParameters,
  ): Promise<common.MessageOnlyResponse> {
    throw new Error('Method not implemented.');
  }
  async fetchLasURL(params: types.FetchLasURLParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/las`)).data;
  }
  async fetchLazUrl(params: types.FetchLazUrlParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/laz`)).data;
  }
  async fetchScanURL(params: types.FetchScanURLParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/scan`)).data;
  }
  async fetchObjUrl(params: types.FetchObjUrlParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/obj`)).data;
  }
  async fetchDxfTerrainModelUrl(
    params: types.FetchDxfTerrainModelUrlParameters,
  ): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/terrain-dxf`))
      .data;
  }
  async fetchReportURL(
    params: types.FetchReportURLParameters,
  ): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/report`)).data;
  }
  async fetchTifURL(params: types.FetchTifURLParameters): Promise<common.DownloadURLResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/tif`, {
        params: params.query,
      })
    ).data;
  }
  async fetchWebpUrl(params: types.FetchWebpUrlParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/webp`)).data;
  }
  async fetchWebpWorldUrl(
    params: types.FetchWebpWorldUrlParameters,
  ): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/webp-world`))
      .data;
  }
  async fetchTfwUrl(params: types.FetchTfwUrlParameters): Promise<common.DownloadURLResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/tfw`, {
        params: params.query,
      })
    ).data;
  }
  async fetchAgisoftProjectURL(
    params: types.FetchAgisoftProjectURLParameters,
  ): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/agisoftproject`))
      .data;
  }
  async fetchXMLURL(params: types.FetchXMLURLParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/xml`)).data;
  }
  async saveXml(params: types.SaveXmlParameters): Promise<void> {
    return (
      await this.axios.put(`${this.serviceEndpoint}/${params.path.geodataId}/xml`, params.body)
    ).data;
  }
  async fetchPhotos(params: types.FetchPhotosParameters): Promise<types.GetPhotosResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/photos`, {
        params: params.query,
      })
    ).data;
  }
  async createJob(params: types.CreateJobParameters): Promise<void> {
    return (
      await this.axios.post(`${this.serviceEndpoint}/${params.path.geodataId}/job`, params.body)
    ).data;
  }

  async createImageDownloadRequest(
    params: types.CreateImageDownloadRequestParameters,
  ): Promise<types.CreateImageDownloadRequestResponse> {
    return (
      await this.axios.post(
        `${this.serviceEndpoint}/${params.path.geodataId}/image-download-request`,
      )
    ).data;
  }

  async createTerrainModelJob(params: types.CreateTerrainModelJobParameters): Promise<void> {
    await this.axios.post<types.CreateTerrainModelJobParameters>(
      `${this.serviceEndpoint}/${params.path.geodataId}/terrain-model`,
      params.body,
    );
  }

  async deleteTerrainModel(params: types.DeleteTerrainModelParameters): Promise<void> {
    await this.axios.delete<types.DeleteTerrainModelParameters>(
      `${this.serviceEndpoint}/${params.path.geodataId}/terrain-model`,
    );
  }

  async fetchJobs(params: types.FetchJobsParameters): Promise<types.FetchJobsResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/jobs`)).data;
  }

  async getFilteredPointCloudUrl(
    params: types.GetFilteredPointCloudUrlParameters,
  ): Promise<common.DownloadURLResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/filtered-point-cloud`)
    ).data;
  }

  async createFilteredPointCloudJob(
    params: types.CreateFilteredPointCloudJobParameters,
  ): Promise<void> {
    await this.axios.post<types.CreateFilteredPointCloudJobParameters>(
      `${this.serviceEndpoint}/${params.path.geodataId}/filtered-point-cloud`,
      params.body,
    );
  }

  async deleteFilteredPointCloud(params: types.DeleteFilteredPointCloudParameters): Promise<void> {
    await this.axios.delete<types.DeleteFilteredPointCloudParameters>(
      `${this.serviceEndpoint}/${params.path.geodataId}/filtered-point-cloud`,
    );
  }

  async getCoordinateSystem(
    params: types.GetCoordinateSystemParameters,
  ): Promise<types.CoordinateSystemResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/coordinate-system`)
    ).data;
  }

  async getSignedRequestParameters(
    params: types.GetSignedRequestParametersParameters,
  ): Promise<common.SignedRequestResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/signed-request`))
      .data;
  }

  async createPendingGeodata({
    body,
  }: types.CreatePendingGeodataParameters): Promise<types.GetGeodataResponse> {
    return (await this.axios.post(`${this.serviceEndpoint}/pending`, body)).data;
  }

  async getImages(params: types.GetImagesParameters): Promise<types.GetGeodataImagesResponse> {
    const queryParams = [];

    if (params.query.include) {
      queryParams.push(...toUrlSearchParams('include', params.query.include));
    }

    if (params.query.limit !== undefined) {
      queryParams.push(['limit', params.query.limit.toString()]);
    }

    if (params.query.offset !== undefined) {
      queryParams.push(['offset', params.query.offset.toString()]);
    }

    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/images`, {
        params: new URLSearchParams(queryParams),
      })
    ).data;
  }

  async getMarkers(params: types.GetMarkersParameters): Promise<types.GetGeodataMarkersResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/markers`)).data;
  }

  async putMarker(params: types.PutMarkerParameters): Promise<types.PutGeodataMarkerResponse> {
    return (
      await this.axios.put(
        `${this.serviceEndpoint}/${params.path.geodataId}/markers/${params.path.markerId}`,
        params.body,
      )
    ).data;
  }

  async deleteMarker(params: types.DeleteMarkerParameters): Promise<void> {
    await this.axios.delete(
      `${this.serviceEndpoint}/${params.path.geodataId}/markers/${params.path.markerId}`,
    );
  }

  async patchGeodata({
    body,
    path,
    query,
  }: types.PatchGeodataParameters): Promise<types.GetGeodataResponse> {
    return (
      await this.axios.patch(`${this.serviceEndpoint}/${path.geodataId}`, body, {
        params: new URLSearchParams([...toUrlSearchParams('include', query.include)]),
      })
    ).data;
  }

  async patchGcp({ body, path }: types.PatchGcpParameters): Promise<types.PatchGcpResponse> {
    return (
      await this.axios.patch(`${this.serviceEndpoint}/${path.geodataId}/gcp/${path.gcpId}`, body)
    ).data;
  }

  async patchGeodataImage({
    body,
    path,
  }: types.PatchGeodataImageParameters): Promise<types.GetGeodataImageResponse> {
    return (
      await this.axios.patch(
        `${this.serviceEndpoint}/${path.geodataId}/images/${path.imageId}`,
        body,
      )
    ).data;
  }

  async createBoundaryPolygon({
    body,
    path,
  }: types.CreateBoundaryPolygonParameters): Promise<types.CreateBoundaryPolygonResponse> {
    return (
      await this.axios.post(`${this.serviceEndpoint}/${path.geodataId}/boundary-polygon`, body)
    ).data;
  }

  async deleteBoundaryPolygon({ path }: types.DeleteBoundaryPolygonParameters): Promise<void> {
    await this.axios.delete(
      `${this.serviceEndpoint}/${path.geodataId}/boundary-polygon/${path.boundaryPolygonId}`,
    );
  }

  async patchBoundaryPolygon({
    body,
    path,
  }: types.PatchBoundaryPolygonParameters): Promise<types.PatchBoundaryPolygonResponse> {
    return (
      await this.axios.patch(
        `${this.serviceEndpoint}/${path.geodataId}/boundary-polygon/${path.boundaryPolygonId}`,
        body,
      )
    ).data;
  }

  async getBoundaryPolygons({
    path,
  }: types.GetBoundaryPolygonsParameters): Promise<types.GetBoundaryPolygonsResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${path.geodataId}/boundary-polygon`))
      .data;
  }

  async createMarkerEstimate(
    params: types.CreateMarkerEstimateParameters,
  ): Promise<types.CreateGeodataMarkerEstimateResponse> {
    return (
      await this.axios.post(
        `${this.serviceEndpoint}/${params.path.geodataId}/markers/${params.path.markerId}/estimate`,
        params.body,
      )
    ).data;
  }
  async getMarkerEstimates(
    params: types.GetMarkerEstimatesParameters,
  ): Promise<types.GetMarkerEstimatesResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/marker-estimates`)
    ).data;
  }

  async patchMarkerEstimates(
    params: types.PatchMarkerEstimatesParameters,
  ): Promise<types.PatchMarkerEstimatesResponse> {
    return (
      await this.axios.patch(
        `${this.serviceEndpoint}/${params.path.geodataId}/marker-estimates`,
        params.body,
      )
    ).data;
  }

  async patchGeodataImages(
    params: types.PatchGeodataImagesParameters,
  ): Promise<types.PatchGeodataImagesResponse> {
    return (
      await this.axios.patch(`${this.serviceEndpoint}/${params.path.geodataId}/images`, params.body)
    ).data;
  }
}
